module.exports = __webpack_public_path__ + "static/appleTouchIcon-72f5dcf02d0f4ba52331ce3e5e435ffd.png";